'use client'

import React from 'react'
import { Printer } from 'lucide-react'

export function PrintButton() {
  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="wl-btn wl-btn-primary no-print"
    >
      <Printer size={16} />
      <span>Print This Article</span>
    </button>
  )
}
